import { render } from "./OcrVerificationForm.vue?vue&type=template&id=6ae9b952&scoped=true"
import script from "./OcrVerificationForm.vue?vue&type=script&lang=js"
export * from "./OcrVerificationForm.vue?vue&type=script&lang=js"

import "./OcrVerificationForm.vue?vue&type=style&index=0&id=6ae9b952&lang=scss"
import "./OcrVerificationForm.vue?vue&type=style&index=1&id=6ae9b952&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae9b952"]])

export default __exports__